require('./confirm-alert.scss');

const template = require('./confirm-alert.html');

class ConfirmAlert {
    _container = null;
    _resolve = null;
    _reject = null;
    _handlers = {};
    _options = {
        classNames: []
    };

    constructor(wrapper, TranslationService, options = {}) {
        this._prepareOptions(options);

        this._translationPromise = TranslationService.getTranslation();
        this._translate = TranslationService.translate.bind(TranslationService);

        this._init(wrapper);
    }

    _prepareOptions(options) {
        Object.keys(this._options).forEach((key) => {
            if (options.hasOwnProperty(key)) this._options[key] = options[key];
        });
    }

    _init(wrapper) {
        let container = document.createElement('div');
        let {classNames} = this._options;

        container.classList.add('info-editor-alert', ...classNames);

        container.innerHTML = template;

        wrapper.appendChild(container);

        this._container = container;
        this._title = this._container.querySelector('.info-editor-alert__message');
        this._confirm = this._container.querySelector('.info-editor-alert__confirm');
        this._cancel = this._container.querySelector('.info-editor-alert__cancel');

        this._bindEvents();
    }

    _bindEvents() {
        this._addHandler('confirm', this._confirm, this.confirm.bind(this));
        this._addHandler('cancel', this._cancel, this.cancel.bind(this));
    }

    _addHandler(name, element, handler) {
        if (!element || !element || !handler) return;

        this._handlers[name] = {
            handler: handler,
            element: element
        };

        element.addEventListener('click', this._handlers[name].handler);
    }

    _unbindEvents() {
        Object.keys(this._handlers).forEach((key) => {
            let element = this._handlers[key].element;
            let handler = this._handlers[key].handler;

            element.removeEventListener('click', handler);

            delete this._handlers[key];
        });
    }

    _show() {
        this._container.classList.add('show');
    }

    _hide() {
        this._container.classList.remove('show');
    }

    show(title) {
        return this._translationPromise.then(() => {
            this._title.innerText = this._translate(title);
            this._show();

            return new Promise((resolve, reject) => {
                this._resolve = resolve;
                this._reject = reject;
            });
        });
    }

    confirm() {
        this._resolve();

        this._resolve = null;
        this._reject = null;

        this._hide();
    }

    cancel() {
        this._reject();

        this._resolve = null;
        this._reject = null;

        this._hide();
    }

    destroy() {
        this._unbindEvents();

        this._container.parentNode.removeChild(this._container);
    }
}

export default ConfirmAlert;